var SPScript = require("spscript");
require("./breadcrumb.css");

var data = require("./data");
var create = function(containerSelector) {
	var component = {};
	component.container = document.querySelector(containerSelector);
	component.fullBreadcrumb = [];
	component.breadcrumbTermId = "";
	component.init = function() {
		data.getFullBreadcrumb()
			.then(b => component.fullBreadcrumb = b)
			.then(data.getBreadcrumbTermId)
			.then(id => component.breadcrumbTermId = id)
			.then(getBreadcrumbPath)
			.then(component.render);
	}

	var getBreadcrumbPath = function() {
		if (!component.breadcrumbTermId) return [];
		var path = [];
		var matchedPath = null;
		var findMatch = function(term) {
			path.push(term);
			if (term.id === component.breadcrumbTermId) {
				matchedPath = path.slice(0);
			}
			term.children.forEach(findMatch);
			path.pop();
		}
		component.fullBreadcrumb.forEach(findMatch)
		return matchedPath || [];
	}

	// Render the main guts of the component right away
	component.render = function(breadcrumbTerms) {
		var html = breadcrumbTerms.map(t => {
			// if there is a url, render an anchor tag, otherwise just text
			var innerElement = t.props.Url ? `<a href='${t.props.Url}'>${t.name}</a>` : t.name
			return `<span class='breadcrumb-item ${(t.props.CssClass || "")}'>${innerElement}</span>`
		}).join("")

		if (component.container) {
			component.container.innerHTML = html;
			component.container.className += " ready";
		}
	};
	SPScript.utils.waitForLibrary("_spPageContextInfo.pageListId").then(component.init);
	return component;
};


module.exports = { create: create };


// WEBPACK FOOTER //
// ./src/scripts/components/breadcrumb/index.js